import { ConsignmentStockInRequestListPage } from "@/features/consignment-stock-in-request/pages/ConsignmentStockInRequestListPage";
import { createFileRoute } from "@tanstack/react-router";

// List stays mounted underneath.
export const Route = createFileRoute("/vendor/consignment-stock-in-request")({
	component: ConsignmentStockInRequestListPage,
});
